module.exports = __webpack_public_path__ + "static/img/1.30908bb1.png";